import React, { Component } from "react";
import { Search } from "@material-ui/icons/";
import { withStyles } from "@material-ui/core/styles";
import { SwipeableDrawer, Fab, Grid, Tooltip } from "@material-ui/core";
import ItensPesquisa from "./ItensPesquisa";
import ModalNewEdition from "./ModalNewEdition";
import AcquirersWrapper from "./style";

const styles = (theme) => ({
  buttonAdd: {
    backgroundColor: "#699E42",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#2b7b2f",
    },
  },
});

class ActionAdquirentes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controller: false,
      controllerModal: false,
      actionStateEdit: null,
      disabled: false,
    };

    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.actionPesquisa = this.actionPesquisa.bind(this);
    this.actionEdit = this.actionEdit.bind(this);
    this.liberarEdtion = this.liberarEdtion.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    state.actionStateEdit =
      props.acquirerEdit != null ? props.acquirerEdit : state.actionStateEdit;

    if (state.actionStateEdit !== null) return { controllerModal: true };
    else return { controllerModal: false };
  }

  toggleDrawer(action) {
    this.setState({
      controller: action,
    });
  }

  cancelAcquirer() {
    this.setState({
      actionStateEdit: null,
    });

    this.props.cancelAcquirer();
  }

  actionPesquisa(objPesquisa) {
    this.props.filtraData(objPesquisa);
    this.toggleDrawer(false);
  }

  actionEdit(objEdit) {
    this.props.actionEdit(objEdit);
    this.setState({
      actionStateEdit: null,
    });

    this.props.cancelAcquirer();
  }

  liberarEdtion() {
    this.setState({
      disabled: true,
    });
  }

  render() {
    const { controller, controllerModal, actionStateEdit, disabled } =
      this.state;

    return (
      <AcquirersWrapper>
        <Grid flex spacing={3} container justifyContent="flex-end">
          <Grid item>
            <Fab   style={{ backgroundColor: "#0066b2", color: "#fff" }} >
              <Tooltip title="Pesquisar">
                <Search
                  id="btnSubmitSearch"
                  variant="primary"
                  onClick={() => this.toggleDrawer(true)}
                />
              </Tooltip>
            </Fab>
          </Grid>
        </Grid>
        <SwipeableDrawer
          swipeAreaWidth={10}
          anchor="right"
          open={controller}
          onClose={() => this.toggleDrawer(false)}
        >
          <ItensPesquisa actionPesquisa={this.actionPesquisa} />
        </SwipeableDrawer>
        <ModalNewEdition
          open={controllerModal}
          handleClose={() => this.cancelAcquirer()}
          actionSave={this.actionSave}
          acquirer={actionStateEdit}
          disabled={disabled}
          actionEdit={this.actionEdit}
          liberarEdtion={this.liberarEdtion}
        />
      </AcquirersWrapper>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ActionAdquirentes);
